import React, { Component } from 'react';
import { Link } from 'react-router';
import auth from '../../Auth/firebase-auth';

class Nav extends Component {
  constructor () {
    super ();
    this.handleSignOut = this.handleSignOut.bind(this);
  }
  static contextTypes = {
    router: React.PropTypes.object
  }

  handleSignOut (e) {
    e.preventDefault();
    auth.logout().then(user => {
      console.log('user signed out');
      this.context.router.push('/');
    }).catch(err => {
      console.log(err);
    });
  }

  render () {
    return (
      <div className="container">
        <nav className="main-nav">
          <ul className="nav nav-tabs">
            <li className={this.context.router.isActive('/') ? 'active' : null}><Link to="/" activeClassName="active" >Home</Link></li>
            <li className={this.context.router.isActive('/books') ? 'active' : null}><Link to="/books" activeClassName="active" >All Books</Link></li>
            <li className={this.context.router.isActive('/keywords') ? 'active' : null}><Link to="/keywords" activeClassName="active" >Keywords</Link></li>
            { this.props.user ? <li className={this.context.router.isActive('/books/add') ? 'active' : null}><Link to="/books/add" activeClassName="active" >Add</Link></li> : null }
            { this.props.user ? <span className="user-signed-in">Signed In: { this.props.user.email } - <a onClick={this.handleSignOut} >Logout</a></span> : null}
          </ul>
        </nav>
      </div>
    );

  }

}

export default Nav;



/** WEBPACK FOOTER **
 ** ./src/components/Layout/Nav.js
 **/